import { render, staticRenderFns } from "./editorHeader.vue?vue&type=template&id=131220b0&scoped=true&"
import script from "./editorHeader.vue?vue&type=script&lang=js&"
export * from "./editorHeader.vue?vue&type=script&lang=js&"
import style0 from "./editorHeader.vue?vue&type=style&index=0&id=131220b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131220b0",
  null
  
)

export default component.exports